import { generatePath } from "react-router";
import { stringify } from "query-string";

import { ActiveToolboxFacetType, ActiveToolFacetType, Single } from "types";

class URLService {
  singlePaths: Partial<Record<Single, string>> = {};

  constructor() {
    const singlePathsContainer = document.querySelector<HTMLElement>(
      "[data-single-paths]"
    );

    if (!singlePathsContainer) return;

    const paths = singlePathsContainer.dataset.singlePaths;
    // singlePathsContainer.dataset.singlePaths = ""; // cleanup

    if (!paths) return;

    this.singlePaths = JSON.parse(paths);
  }

  getSinglePath = (type: Single) => this.singlePaths[type] || "";

  get searchUrlPattern(): string {
    return `${this.getSinglePath(Single.search)}/:query/:page`;
  }

  generateSearchUrl = (query: string, page: number): string => {
    return generatePath(this.searchUrlPattern, {
      query,
      page,
    });
  };

  generateToolSearchUrl = (data: ActiveToolFacetType): string => {
    const queryParams = stringify(data, {
      skipNull: true,
      skipEmptyString: true,
    });

    return `${this.getSinglePath(Single.toolSearch)}?${queryParams}`;
  };

  generateToolboxSearchUrl = (data: ActiveToolboxFacetType): string => {
    const queryParams = stringify(data, {
      skipNull: true,
      skipEmptyString: true,
    });

    return `${this.getSinglePath(Single.toolboxSearch)}?${queryParams}`;
  };
}

// Make sure only one instance of URLService is created
const urlService = new URLService();
Object.freeze(URLService);

export { urlService };
